module.exports = __webpack_public_path__ + "img/pediasure-vanilla.66e884e7.jpg";